import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import store from 'store';
import toggleScroll from '@/scripts/utils/toggle-body-scroll';
import createEvent from '@/scripts/utils/create-event';
import { ROOT_ELEMENT } from '@/scripts/constants';

const STORAGE_KEY = 'hasSeenPreloader';
const STORAGE_VALUE = 'true';
const PRELOADER_SELECTOR = '[data-role="preloader"]';

window.addEventListener('load', () => {
  store.set(STORAGE_KEY, STORAGE_VALUE);
});

document.addEventListener('DOMContentLoaded', () => {
  const tl = new TimelineMax({ delay: 1 });
  const preloader = document.querySelector(PRELOADER_SELECTOR);
  const paths = [preloader.querySelector('.path1'), preloader.querySelector('.path2')];
  const coverItems = $('[data-animation="cover-animation"]').children();

  // const haveSeenPreloader = store.get(STORAGE_KEY) === STORAGE_VALUE;
  // in case you need one-time animation

  TweenMax.set(coverItems, { autoAlpha: 0, willChange: 'transform, opacity', x: -200 });

  toggleScroll(true, null);
  paths.forEach(path => path.classList.add('animate'));
  tl.add(TweenMax.to(preloader, 0.3, {
    autoAlpha: 0,
    onComplete: () => {
      toggleScroll(false, null);
    },
  }), '+=2.2');

  tl.add(TweenMax.staggerTo(coverItems, 0.6, {
    autoAlpha: 1,
    x: 0,
  }, 0.2, () => {
    TweenMax.set(coverItems, { clearProps: 'all' });
    ROOT_ELEMENT.dispatchEvent(createEvent('preloaderEnd')); // used in cookies message
  }));
});



// WEBPACK FOOTER //
// ./scripts/elements/preloader.js